import TypesUtils from "./typesUtils";

class StringUtils {
    static prefixAll(strs, prefix) {
        return strs.map((str) => {
            return prefix + str;
        });
    }

    static isPrefix(prefix, str) {
        return (
            TypesUtils.notUndefOrNull(str) &&
            TypesUtils.notUndefOrNull(str) &&
            str.substring(0, prefix.length) === prefix
        );
    }

    static notNullNotEmptyNoStrNull(str) {
        return this.notNullNotEmpty(str) && str !== "null";
    }

    static notNullNotEmpty(str) {
        return TypesUtils.isStr(str) && !TypesUtils.undefOrNull(str) && str !== "";
    }

    static nullOrEmpty(str) {
        return (str === "" || TypesUtils.undefOrNull(str));
    }

    static someNotNullNotEmpty(arrStr) {
        return arrStr.some((str) => this.notNullNotEmpty(str));
    }

    static encodeUTF16(str) {
        var buf = new ArrayBuffer(str.length * 2);
        var bufView = new Uint16Array(buf);
        for (var i = 0, strLen = str.length; i < strLen; i++) {
            bufView[i] = str.charCodeAt(i);
        }
        return bufView.toString();
    }

    static capitalFirst(str) {
        if (!TypesUtils.isStr(str)) return "";
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    static sumLenghts(stringsArray) {
        let lsum = 0;
        stringsArray.forEach((str) => {
            lsum += str.length;
        });
        return lsum;
    }

    static noAccentMark(str) {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    static firstCharUpperCase(s) {
        if (typeof s !== "string") return "";
        return s.charAt(0).toUpperCase() + s.slice(1);
    }

    static removeEmptyLines(text) {
        if (TypesUtils.isStr(text)) return text.replace(/^\s*[\r\n]/gm, "");
        else if (TypesUtils.isArray(text)) {
            let res = [];
            text.forEach((line) => {
                if (this.notNullNotEmpty(line.replace(/^\s*[\r\n]/gm, ""))) res.push(line);
            });
            return res;
        }
        return null;
    }

    static splitByLines(text) {
        return text.split(/\r|\r\n|\n/);
    }

    static includesAll(text, texts) {
        return !texts.some((s) => !text.toLowerCase().includes(s.toLowerCase()));
    }

    static includesSome(text, texts) {
        return texts.some((s) => !text.toLowerCase().includes(s.toLowerCase()));
    }

    static eqIC(s1, s2) {
        if (!s1 || !s2) return false;
        return s1.toUpperCase() === s2.toUpperCase();
    }

    static removeConsecutiveSpaces(str) {
        return str.replace(/ +(?= )/g, "");
    }

    static removeNonAscii(str) {
        return str.replace(/[^a-zA-Z\s0-9=/]+/gi, '');
    }

    static removeEOLs(str) {
        return this.removeConsecutiveSpaces(str.replace(/[\r\n|\n]+/g, " "));
    }

    static removeZerosPrefix(str) {
        return str.replace(/^0+(?!\.|$)/, "");
    }

    static boolToSiNo(b) {
        return b ? "Si" : "No";
    }

    static numToStr(n) {
        if (TypesUtils.isNumberOrStrNum(n)) {
            if (Number.isInteger(n)) return parseInt(n);
            else return parseFloat(n);
        }
        return "";
    }

    static concatWithSep(accum, s, sep) {
        if (accum === "") return s;
        return accum + sep + s;
    }

    static eqSome(str,strArr){
        return strArr.some(s=>s === str)
    }

    /**
     * Retorna el mismo array pero sin elementos null, undefined o string vacios
     *
     * @param {Array[string]} arrStr
     */
    static removeEmptyStr(arrStr){
        let res=[]
        if (TypesUtils.notUndefOrNull(arrStr))
            arrStr.forEach(elem=>{
                if (this.notNullNotEmpty(elem))
                    res.push(elem)
            })
        return res;
    }
}

export default StringUtils;
